<template>
    <div class="grid" v-if="getMovil() == null || getParada() == null">
       <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-2">
           <Message severity="error" class="p-col-12">
               Para poder operar en el sistema debe seleccionar el comedor y parada donde está cumpliendo funciones.
           </Message>
       </div>
   </div>
   <div class="grid" v-if="getMovil() != null && getParada() != null">
       <div class="col-12 md:col-6 xl:col-3">
           <div class="card grid-nogutter widget-overview-box widget-overview-box-1">
               <span class="overview-icon">
                   <i class="pi pi-chart-pie"></i>
               </span>
               <span class="overview-title">Remitos del día</span>
               <div class="grid overview-detail">
                   <div class="col-12">
                       <div class="overview-subtext">Visualización de los remitos de entrada y salida del día de hoy en el comedor seleccionado en el sistema.</div>
                   </div>
               </div>
           </div>
       </div>
           
       <div class="grid p-mt-5">
           <div class="col-12">
               <div class="card">
                   <Message class="p-col-12">
                       Usted está operando en:<br>
                       <i class="pi pi-map"/> {{getMovilName()}}<br>
                       <i class="pi pi-map-marker"/> <i>{{getParadaName()}}</i>
                   </Message>
                   <Toolbar>
                       <template v-slot:left>
                           
                       </template>

                       <template v-slot:right>
                           <Button label="Recargar remitos" @click="reloadData()" icon="pi pi-refresh" iconPos="left" :loading="loading"/>
                       </template>
                   </Toolbar>
                   
                    <div class="p-field p-col-12 p-md-12">
                        <DataTable :value="remitos" responsiveLayout="scroll" :filters="filters" :loading="loadingtable1" class="mt-3 p-shadow-2"
                        :paginator="true" :rows="10" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        :rowsPerPageOptions="[10,20,50]" currentPageReportTemplate="Mostrando {first} al {last} de {totalRecords}"
                        >
                            <template #header>
                                <div class="table-header">
                                    <h6 class="p-mb-2">Remitos del día</h6>
                                    <span class="p-input-icon-left p-mb-2">
                                        <i class="pi pi-search" />
                                        <InputText v-model="filters['global'].value" placeholder="Criterio de búsqueda" style="width: 100%"/>
                                    </span>
                                </div>
                            </template>
                            <template #empty>
                                No hay información relacionada con remitos del día de hoy.
                            </template>
                            <template #loading>
                                Cargando remitos subidos hoy. Espere por favor.
                            </template>
                            <Column field="hora" header="Hora" sortable="true"></Column>
                            <Column field="tecnico" header="Técnico"></Column>
                            <Column field="tipo" header="Tipo"></Column>
                            <Column field="viandas" header="Cantidad"></Column>
                            <Column field="observacion" header="Observación"></Column>
                        </DataTable>
                    </div>
               </div>
           </div>
       </div>   
   </div>
   

   <Dialog header="Aguarde..." v-model:visible="wait" :style="{width: '150px'}" :modal="true" :position="left">
       <div align="center">
           <ProgressSpinner style="width:50px;height:50px" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"/>
       </div>
   </Dialog>
   
</template>

<script>
import SmartService from '../service/SmartService';
import {FilterMatchMode,FilterOperator} from 'primevue/api';
export default {
   data() {
       return {
           wait: false,
           loading: false,
           loadingtable1: false,
           remitos: null,
           filters: {
               'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
               'hora': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.EQUALS}]},
               'tecnico': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]},
               'tipo': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]},
               'viandas': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.EQUALS}]},
               'observacion': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]},
           },
       }
   },	
   smartService: null,
   created() {
       this.smartService = new SmartService();
   },
   mounted() {
       this.reloadData();
   },
   methods: {
       getMovil(){
           return localStorage.movil_id;
       },

       getParada(){
           return localStorage.parada_id;
       },

       getIdTec(){
           return localStorage.tec_id;
       },

       getMovilName(){
           return localStorage.movil_name;
       },

       getParadaName(){
           return localStorage.parada_name;
       },

       getUsuario(){
           return localStorage.nombre;
       },

       async cargarRemitosHoy(){
           this.loadingtable1 = true;
           this.loading = true;
           this.remitos = [];
           this.smartService.obtenerRemitosHoy(Number(this.getMovil())).then(data => {
               for (let r of data){
                   let aux = {hora:r.horaRetiro, tecnico:r.tecNombre, tipo:r.tipoStr, viandas:r.cantidadViandas, observacion:r.observacion};
                   this.remitos.push(aux);  
               }
               this.loadingtable1 = false;
               this.loading = false;
           });
       },

       reloadData(){
           this.cargarRemitosHoy();
       }

   },
}
</script>

<style scoped lang="scss">
   .table-header {
       display: flex;
       align-items: center;
       justify-content: space-between;
   }
   .overview-detail {
       text-align: left;
       margin-top: 2rem;

       .p-col-6 {
           padding: .5rem;
       }
   }
</style>